var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 0.75,
    y: 0.75,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    stroke: "#E40F94",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5861 9H15.4138C12.4286 9 10 11.4286 10 14.4138V23.5863C10 26.5714 12.4286 29 15.4138 29H24.5863C27.5714 29 30 26.5714 30 23.5863V14.4138C30 11.4286 27.5714 9 24.5861 9ZM28.8275 23.5863C28.8275 25.9248 26.9248 27.8275 24.5861 27.8275H15.4138C13.0751 27.8275 11.1725 25.9248 11.1725 23.5863V14.4138C11.1725 12.0751 13.0751 10.1725 15.4138 10.1725H24.5863C26.9248 10.1725 28.8275 12.0751 28.8275 14.4138V23.5863Z",
    fill: "#E40F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.5315C16.9845 13.5315 14.5314 15.9846 14.5314 19.0001C14.5314 22.0156 16.9845 24.4687 20 24.4687C23.0154 24.4687 25.4686 22.0156 25.4686 19.0001C25.4686 15.9846 23.0154 13.5315 20 13.5315ZM20 23.2962C17.6312 23.2962 15.7039 21.369 15.7039 19.0001C15.7039 16.6313 17.6312 14.704 20 14.704C22.3689 14.704 24.2961 16.6313 24.2961 19.0001C24.2961 21.369 22.3689 23.2962 20 23.2962ZM25.5993 11.5894C24.7082 11.5894 23.9834 12.3143 23.9834 13.2053C23.9834 14.0964 24.7082 14.8213 25.5993 14.8213C26.4905 14.8213 27.2154 14.0964 27.2154 13.2053C27.2154 12.3142 26.4904 11.5894 25.5993 11.5894ZM25.5993 13.6487C25.3549 13.6487 25.1559 13.4497 25.1559 13.2053C25.1559 12.9607 25.3549 12.7619 25.5993 12.7619C25.8439 12.7619 26.0429 12.9607 26.0429 13.2053C26.0429 13.4497 25.8439 13.6487 25.5993 13.6487Z",
    fill: "#E40F94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/Instagram Icon.0c1916bb18a5e3eb3e49ca18011cf2a8.svg";
export { ForwardRef as ReactComponent };